module.exports = __webpack_public_path__ + "img/footer-right-pic.d75ed1bb.png";